import React, { useContext, useEffect, useState } from 'react';
import { ContextGloball } from './Context/ContextGlobal';
import Offcanvas from 'react-bootstrap/Offcanvas';
import valPer from './Tools/VerificarPermisos';

function MenuOpciones(props) {
    const { setLogin } = props;
    const [permisos, setPermisos] = useState(' ');    
    const { ventana, setVentana, setTitulo, showMenu, setShowMenu, esReporte, setEsReporte } = useContext(ContextGloball);
    const salirSession = () => {
        setVentana('0');
        setTitulo('');
        setShowMenu(false);
        setLogin(false);
        window.localStorage.clear();
    }
    const validarVentana = (item) => {
        var cls = ventana === item ? "itemMenuOk w-100" : "itemMenu w-100";
        return cls;
    }
    useEffect(() => {
        if (localStorage.getItem('info') != undefined) {
            try {
                var permiso = JSON.parse(localStorage.getItem('info')).PERMISO;
                setPermisos(permiso);
            } catch (error) {
                localStorage.clear();
            }
        }
    }, [])
    return (
        <div>
            <Offcanvas show={showMenu} onHide={() => setShowMenu(false)} placement='end' scroll='true' backdrop='true'
                autoFocus='true'
                bsPrefix='offcanvas offcanvas-end bg-dark' style={{ width: "240px" }}>
                <Offcanvas.Header closeButton closeVariant='white' bsPrefix='offcanvas-header fondoHeader'>
                    <Offcanvas.Title>
                        <button className="btn btn-sm text-light text-start fs-5"
                            onClick={() => { setVentana('0'); setTitulo(''); setShowMenu(false) }}> Menu</button>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {permisos === null &&
                        <ul className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-start align-items-sm-start text-start">
                            <li className={ventana === '12' ? "itemMenuOk w-100" : "itemMenu w-100"}>
                                <a className="btn btn-sm nav-link px-0 align-middle fs-5 text-light text-start"
                                    onClick={() => { setVentana('12'); setTitulo('Kingdom Noticias'); setShowMenu(false); setEsReporte(false); }}>
                                    <i className="fa-brands fa-facebook"></i><span className="ms-1 "> Kingdom Noticias</span></a>
                            </li>
                        </ul>}
                    {permisos !== null &&
                        <ul className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-start align-items-sm-start text-start">
                            <li className={ventana === '12' ? "itemMenuOk w-100" : "itemMenu w-100"}>
                                <a className="btn btn-sm nav-link px-0 align-middle fs-5 text-light text-start"
                                    onClick={() => { setVentana('12'); setTitulo('Kingdom Noticias'); setShowMenu(false); setEsReporte(false); }}>
                                    <i className="fa-solid fa-square-share-nodes"></i><span className="ms-1 "> Kingdom Noticias</span></a>
                            </li>
                            {valPer.validarPermiso('4') && <li className={validarVentana('4')} onClick={() => {
                                setVentana('4');
                                setTitulo('Comunicados');
                                setShowMenu(false);
                                setEsReporte(false);
                            }}>
                                <a className="btn nav-link align-middle px-0 text-light w-100 text-start " >
                                    <i className="fs-4 bi bi-newspaper"></i> <span className="ms-1 fs-5">Comunicados</span>
                                </a>
                            </li>}
                            {valPer.validarPermiso('53') && <li className={validarVentana('5')}>
                                <a className="btn btn-sm nav-link px-0 align-middle fs-5 text-light text-start"
                                    onClick={() => { setVentana('5'); setTitulo('RRHH'); setShowMenu(false); setEsReporte(false); }}>
                                    <i className="fa-solid fa-people-roof"></i><span className="ms-1 "> RRHH</span></a>
                            </li>}
                            {valPer.validarPermiso('7') && <li className={esReporte === true ? "itemMenuOk w-100" : "itemMenu w-100"} onClick={() => {                                
                                setVentana('16');
                                setTitulo('Reportes');
                                setShowMenu(false);
                                setEsReporte(true);
                            }}>
                                <a className="btn nav-link align-middle px-0 text-light w-100 text-start"  >
                                    <i className="bi bi-file-earmark-bar-graph-fill fs-5"></i> <span className="ms-1 fs-5">Reportes</span>
                                </a>
                            </li>}
                            {valPer.validarPermiso('13') && <li className={validarVentana('13')}>
                                <a className="btn btn-sm nav-link px-0 align-middle fs-5 text-light text-start"
                                    onClick={() => { setVentana('13'); setTitulo('Itinerario'); setShowMenu(false); setEsReporte(false); }}>
                                    <i className="fa-solid fa-map"></i><span className="ms-1 "> Itinerario</span></a>
                            </li>}
                            {valPer.validarPermiso('36') && <li className={validarVentana('36')}>
                                <a className="btn btn-sm nav-link px-0 align-middle fs-5 text-light text-start"
                                    onClick={() => { setVentana('36'); setTitulo('Supervisión'); setShowMenu(false); setEsReporte(false); }}>
                                    <i className="fa-solid fa-glasses"></i><span className="ms-1 "> Supervisión</span></a>
                            </li>}
                            {valPer.validarPermiso('51') && <li className={validarVentana('41')}>
                                <a className="btn btn-sm nav-link px-0 align-middle fs-5 text-light text-start"
                                    onClick={() => { setVentana('41'); setTitulo('Modulo Almacen'); setShowMenu(false); setEsReporte(false); }}>
                                    <i className="fa-solid fa-store"></i><span className="ms-1 "> Almacenes</span></a>
                            </li>}
                            {valPer.validarPermiso('11') && <li className={validarVentana('11')}>
                                <a className="btn btn-sm nav-link px-0 align-middle fs-5 text-light text-start"
                                    onClick={() => { setVentana('11'); setTitulo('Procedimientos'); setShowMenu(false); setEsReporte(false); }}>
                                    <i className="fa-solid fa-school-circle-check"></i><span className="ms-1 "> Procedimientos</span></a>
                            </li>}
                            {valPer.validarPermiso('23') && <li className={validarVentana('21')}>
                                <a className="btn btn-sm nav-link px-0 align-middle fs-5 text-light text-start"
                                    onClick={() => { setVentana('21'); setTitulo('Formularios Para Examen o Encuestas'); setShowMenu(false); setEsReporte(false); }}>
                                    <i className="fa-solid fa-list-ol"></i><span className="ms-1 "> Admi Formulario</span></a>
                            </li>}
                            {valPer.validarPermiso('1') && <li className={validarVentana('1')}>
                                <a className="btn btn-sm nav-link px-0 align-middle fs-5 text-light text-start"
                                    onClick={() => { setVentana('1'); setTitulo('Configurar web'); setShowMenu(false); setEsReporte(false); }}>
                                    <i className="fa-solid fa-screwdriver-wrench"></i><span className="ms-1 "> Conf Web</span></a>
                            </li>}
                        </ul>}
                </Offcanvas.Body>
                <div className='mx-auto mb-2'>
                    <a className='btn btn-sm btn-danger px-0 text-light text-center fs-5' onClick={salirSession}><i className="bi bi-person-x-fill ">
                        <span className='ms-1 '>Cerrar Sesión</span></i></a>
                </div>
            </Offcanvas>
        </div>
    )
}

export default MenuOpciones
